<template lang="pug">
#person-project
  h4.mb-2
    a(:href='project.url', target='_blank') {{ project.title }}
  ContentRenderer(:value='project')
  v-table
    tbody
      tr(v-for='(metaInfo, i) in metaTableData')
        td
          v-icon(size="small").mr-1 mdi-chevron-double-right
          span {{ metaInfo.name }}
        td(v-if='!!metaInfo.url')
          a(:href='metaInfo.url', target='_blank') {{ metaInfo.value }}
        td(v-else)
          span {{ metaInfo.value }}
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Project, ProjectMetadata } from '~/interfaces/project'

defineOptions({
  name: 'Project',
})

const props = defineProps({
  project: {
    type: Object as () => Project,
    required: true,
  },
})

const metaTableData = computed(() => {
  const metadata = props.project.metadata ?? []
  const status = props.project.projectStatus
  return [
    ...metadata,
    {
      name: 'Project status',
      value: status,
    },
  ] satisfies Array<ProjectMetadata>
})
</script>
